module.exports = __webpack_public_path__ + "static/media/ruqya.38b15085.png";